$(function () {
  const $body = $('body');
  const $header = $('#header');
  const $placeholder = $('.header-placeholder');
  const $overlay = $('#overlay');
  const $drawerTriggers = $('#drawer-trigger');
  const $drawerContent = $('#drawerContent');
  const $mobileDock = $('#mobile-dock-container');
  const drawerWidth = $('#drawerContent').outerWidth();

  let drawerIsOpen = false;
  let scrollLockSavedY = 0;
  let isAnimating = false;

  // ===== モーダル用ガード =====
  let lastModalOpenAt = 0;
  const MODAL_OPEN_GUARD_MS = 500; // open直後のresize無視

  //
  // 共通: スクロールロック
  //
  let savedY = 0;

  function getScrollY() {
    // ブラウザ差分を吸収
    return window.pageYOffset != null
      ? window.pageYOffset
      : (document.scrollingElement || document.documentElement).scrollTop || 0;
  }

  function disableScroll() {
    $('body')
      .css({
        top: `-${savedY}px`,
      })
      .addClass('scroll-lock');
  }

  function enableScroll() {
    $('body')
      .css({
        top: '',
      })
      .removeClass('scroll-lock');
    window.scrollTo(0, savedY);
  }

  //
  // 共通: オーバーレイ（z-index 指定に対応）
  //
  function showOverlay() {
    $overlay.show();
  }
  function hideOverlay() {
    $overlay.hide();
  }

  //
  // 共通: オーバーレイ＆スクロール
  //
  function updateOverlayAndScroll() {
    /*
    const $body = $('body');
    if (!$body.hasClass('scroll-lock')) {
      $body.attr('data-saved-y', getScrollY()); // 0 もそのまま保存（意図的にトップなら0でOK）
    }
    */

    if (anyOpen()) {
      showOverlay();
      disableScroll();
    } else {
      hideOverlay();
      enableScroll();
    }
  }

  function disableScroll() {
    const $body = $('body');
    $body.addClass('scroll-lock')
    /*
    if (!$body.hasClass('scroll-lock')) {
      const savedY = parseInt($body.attr('data-saved-y') || '0', 10);
      $body
        .css('top', `-${savedY}px`)
        .addClass('scroll-lock');
    }
    */
  }

  function enableScroll() {
    const $body = $('body');
    $body.removeClass('scroll-lock');
    /*
    if ($body.hasClass('scroll-lock')) {
      const savedY = parseInt($body.attr('data-saved-y') || '0', 10);
      $body.removeClass('scroll-lock').css('top', '');
      window.scrollTo(0, savedY);
    }
    */
  }


  //
  // 外側クリック閉じは全て無効化
  //
  $overlay.off('click').on('click', function () {
    instantCloseDrawer();
    instantCloseAllMegaMenus();
    instantCloseAllModals();
    updateOverlayAndScroll();
    $('#content').css('z-index', 2000);
    $('#overlay').css('z-index', 2000);
  });

  //
  // 共通: 可視範囲高さ
  //
  function getVisibleHeight($el) {
    if (!$el.length || !$el.is(':visible')) return 0;
    const rect = $el[0].getBoundingClientRect();
    const windowHeight = window.innerHeight;
    return Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));
  }

  //
  // 固定ヘッダー用 padding-top 設定
  //
  $(function () {
    function updateBodyPadding() {
      const headerHeight = $('#header')[0]?.getBoundingClientRect().height || 0;
      $('body').css('padding-top', headerHeight + 'px');
    }

    updateBodyPadding();
    $(window).on('resize', updateBodyPadding);
  });

  //
  // メガメニュー
  //
  const $triggers = $('.header__menu-item[data-index]');
  const $menus = $('.mega-menu[data-index]');

  function getMenuTop() {
    const scrollTop = $(window).scrollTop();
    return getVisibleHeight($header);
  }

  // --- 中央管理（状態判定／即時クローズ群） ---
  function anyMegaOpen() { return $menus.filter('.is-open').length > 0; }
  function anyModalOpen() { return Array.isArray(allModals) && allModals.some(m => m.isOpen); }
  function anyOpen() { return drawerIsOpen || anyMegaOpen() || anyModalOpen(); }

  function instantCloseDrawer() {
    if (!drawerIsOpen) return;
    $drawerContent.stop(true, true).css({ display: 'none', right: `-${drawerWidth}px` });
    drawerIsOpen = false;
    $drawerTriggers.removeClass('is-active');
    $('#drawer-trigger .icon-toggle').removeClass('is-open');
  }

  function instantCloseAllMegaMenus() {
    const top = getMenuTop();
    $menus.filter('.is-open').each(function () {
      const $menu = $(this);
      const height = $menu.outerHeight();
      $menu.stop(true, true)
        .css({ top: `${top - height}px`, display: 'none' })
        .removeClass('is-open');
    });
    $triggers.filter('.is-open').removeClass('is-open');
  }

  function instantCloseAllModals() {
    if (!Array.isArray(allModals)) return;
    allModals.forEach(m => {
      if (!m || !m.isOpen) return;
      const h = m.getHeight();
      m.$modal.stop(true, true)
        .css({ bottom: `-${h}px`, display: 'none' })
        .removeClass('is-open');
      m.isOpen = false;
    });
  }

  // 自分以外のモーダルのみ即時クローズ
  function instantCloseOtherModals(exceptInstance) {
    if (!Array.isArray(allModals)) return;
    allModals.forEach(m => {
      if (!m || m === exceptInstance || !m.isOpen) return;
      const h = m.getHeight();
      m.$modal.stop(true, true)
        .css({ bottom: `-${h}px`, display: 'none' })
        .removeClass('is-open');
      m.isOpen = false;
    });
  }
  // --- /中央管理 ---

  // 初期位置
  $menus.each(function () {
    const $menu = $(this);
    const height = $menu.outerHeight();
    const top = getMenuTop();
    $menu.css({ top: `${top - height}px`, display: 'none' });
  });

  function closeAllMegaMenus() {
    $menus.filter('.is-open').each(function () {
      const $menu = $(this);
      const height = $menu.outerHeight();
      const top = getMenuTop();
      $menu
        .stop(true, true)
        .animate({ top: `${top - height}px` }, 300, 'easeOutExpo', function () {
          $menu.css('display', 'none').removeClass('is-open');
          $triggers.filter('.is-open').removeClass('is-open');
          updateOverlayAndScroll();
        });
    });
  }

  $triggers.on('click', function (e) {
    e.stopPropagation();
    if (isAnimating) return;

    const $clicked = $(this);
    const index = $clicked.data('index');
    const $targetMenu = $menus.filter(`[data-index="${index}"]`);
    const height = $targetMenu.outerHeight();
    const top = getMenuTop();
    const isOpen = $clicked.hasClass('is-open');
    isAnimating = true;

    if (isOpen) {
      $targetMenu
        .stop(true, true)
        .animate({ top: `${top - height}px` }, 300, 'easeOutExpo', function () {
          $targetMenu.css('display', 'none').removeClass('is-open');
          $clicked.removeClass('is-open');
          isAnimating = false;
          updateOverlayAndScroll();
          $('#overlay').css('z-index', 2000);
        });
    } else {
      // 他を即時クローズ（ドロワー・モーダル）
      instantCloseDrawer();
      instantCloseAllModals();
      $('#overlay').css('z-index', 1900);

      $targetMenu
        .stop(true, true)
        .css({ display: 'block', top: `${top - height}px` })
        .animate({ top: `${top}px` }, 300, 'easeOutExpo', function () {
          $clicked.addClass('is-open');
          $targetMenu.addClass('is-open');
          isAnimating = false;
          updateOverlayAndScroll();
        });
    }
  });

  // メガメニューは resize で閉じる
  $(window).on('resize', closeAllMegaMenus);

  //
  // ドロワー
  //
  function openDrawer() {
    // 他を即時クローズ（メガメニュー・モーダル）
    instantCloseAllMegaMenus();
    instantCloseAllModals();

    drawerIsOpen = true;
    const windowHeight = $(window).height();
    const headerHeight = getVisibleHeight($header);
    const drawerHeight = windowHeight - headerHeight;

    $drawerContent
      .css({
        display: 'block',
        top: `${headerHeight}px`,
        right: `-${drawerWidth}px`,
      })
      .stop(true)
      .animate({ right: '0' }, 300, 'easeOutExpo', function () {
        updateOverlayAndScroll();
      });

    $('#content').css('z-index', 3000);
    $('#overlay').css('z-index', 2400);
    $drawerTriggers.addClass('is-active');
    $('#drawer-trigger .icon-toggle').addClass('is-open');
  }

  function closeDrawer() {
    $drawerContent.animate({ right: `-${drawerWidth}px` }, 300, 'easeOutExpo', function () {
      $drawerContent.css('display', 'none');
      drawerIsOpen = false;
      $(window).trigger('scroll');
      updateOverlayAndScroll();
      $('#content').css('z-index', 2000);
      $('#overlay').css('z-index', 2000);
    });

    $drawerTriggers.removeClass('is-active');
    $('#drawer-trigger .icon-toggle').removeClass('is-open');
  }

  function closeDrawerIfOpen() {
    if (drawerIsOpen) closeDrawer();
  }

  // トリガー：押下時にモーダル＆メガメニューを必ず閉じる
  $drawerTriggers.on('click', function () {
    instantCloseAllModals();
    instantCloseAllMegaMenus();
    updateOverlayAndScroll();
    drawerIsOpen ? closeDrawer() : openDrawer();
  });

  // ドロワー内のクリックでもモーダルを閉じる
  $(document).on('click', '#drawerContent .menu-drawer__navLink, #drawerContent a, #drawerContent button', function () {
    instantCloseAllModals();
    updateOverlayAndScroll();
  });

  //
  // ドロワーメニュー開閉（アコーディオン）
  //
  $('.menu-drawer__menu .menu-drawer__navLink').on('click', function () {
    const $navLink = $(this);
    const $submenu = $navLink.next('ul');
    const $plus = $navLink.find('.plus-button');

    $submenu.slideToggle(300, 'easeOutExpo');
    const isExpanded = $navLink.attr('aria-expanded') === 'true';
    $navLink.attr('aria-expanded', !isExpanded);
    $plus.toggleClass('is-open');
  });

  //
  // モーダル（検索・カテゴリ）
  //
  class ModalController {
    constructor(modalSelector, triggerSelector, options = {}) {
      this.$modal = $(modalSelector);
      this.triggerSelector = triggerSelector;
      this.options = options;
      this.isOpen = false;

      this.init();
      this.bindEvents();
    }

    getHeight() {
      return this.$modal.outerHeight();
    }

    init() {
      const height = this.getHeight() || 400;
      this.$modal.css({
        position: 'fixed',
        left: 0,
        display: 'none',
        bottom: `-${height}px`
      });
    }

    open() {
      // 他を即時クローズ（ドロワー・メガメニュー）
      instantCloseDrawer();
      instantCloseAllMegaMenus();

      // 先に overlay + scroll-lock を有効化（途中のresize/scroll耐性）
      showOverlay(2000);
      disableScroll();

      // ガードセット（open直後のresizeを無視）
      lastModalOpenAt = Date.now();

      const dockHeight = $mobileDock.outerHeight() || 0;
      if (this.$modal.attr('id') === 'catModal') adjustCatModalHeight();

      const height = this.getHeight();

      this.$modal
        .stop(true, true)
        .css({ display: 'block', bottom: `-${height}px` })
        .animate({ bottom: dockHeight }, 300, 'easeOutExpo', () => {
          this.isOpen = true;
          this.$modal.addClass('is-open');
          updateOverlayAndScroll();
        });
    }

    close() {
      const height = this.getHeight();
      this.$modal
        .stop(true, true)
        .animate({ bottom: `-${height}px` }, 300, 'easeOutExpo', () => {
          this.$modal.css('display', 'none').removeClass('is-open');
          this.isOpen = false;
          updateOverlayAndScroll();
        });
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        // 自分以外のモーダルを即時クローズしてから開く
        instantCloseOtherModals(this);
        this.open();
      }
    }

    bindEvents() {
      $(document).on('click', this.triggerSelector, (e) => {
        e.stopPropagation();
        this.toggle();
      });
    }

    // 外側クリックで閉じる機能は無し
    // handleOutsideClick(e) { /* noop */ }

    reinitOnResize() { this.init(); }
  }

  function adjustCatModalHeight() {
    const $catModal = $('#catModal');
    const dockHeight = $mobileDock.outerHeight() || 0;
    const maxHeight = $(window).height() - dockHeight;
    if (maxHeight > 0) {
      $catModal.css({ 'max-height': `${maxHeight}px`, 'overflow-y': 'auto' });
    }
  }

  const searchModal = new ModalController('#searchModal', '.dock_search');
  const catModal = new ModalController('#catModal', '.dock_category');
  const allModals = [searchModal, catModal];

  //inputフォーカス中は閉じない
  let isSearchInputFocused = false;
  $(document)
    .on('focusin', '#searchModal .top__search input[type=text]', function () {
      isSearchInputFocused = true;
    })
    .on('focusout', '#searchModal .top__search input[type=text]', function () {
      isSearchInputFocused = false;
    });

  // モーダルは scroll では閉じない。resize のみ（open直後はガード）
  $(window).on('resize', () => {
    if (Date.now() - lastModalOpenAt < MODAL_OPEN_GUARD_MS) return;
    if (isSearchInputFocused) return;
    allModals.forEach(m => m.isOpen && m.close());
  });

  $(window).on('resize', adjustCatModalHeight);
  adjustCatModalHeight();
});
